import { countBy } from 'lodash';
import { Moment } from 'moment';
import BaseModel from '@/shared/models/BaseModel';
import User from '@/shared/models/User';
import ChecklistItemStatus from '../constants/ChecklistItemStatus';
import ChecklistScore from '../constants/ChecklistScore';
import ChecklistCounters from './ChecklistCounters';
import SignatureSummary from './SignatureSummary';
import ChecklistSegment from './ChecklistSegment';

export interface ChecklistId {__checklistId: number}

export default class Checklist extends BaseModel<ChecklistId> {
  status: ChecklistScore | null = null;
  description = '';
  counters!: ChecklistCounters;
  finishedOn: Moment | null = null;
  finishedBy: User | null = null;
  segments: Array<ChecklistSegment> = [];
  visibleToCustomer = false;
  signatureSummaries: Array<SignatureSummary> = [];

  recalculateCounters(): void {
    const items = this.segments.flatMap(s => s.items);
    const counts = countBy(items, 'status');
    this.counters.good = counts[ChecklistScore.GOOD] ?? 0;
    this.counters.caution = counts[ChecklistScore.CAUTION] ?? 0;
    this.counters.bad = counts[ChecklistScore.BAD] ?? 0;

    this.counters.answered = items.filter(i => i.status !== ChecklistItemStatus.EMPTY).length;
  }
}
